const ADMIN_ROUTE_PRIORITY = [
  { path: 'dashboard' },
  { path: 'campaigns', permission: 'view-campaigns' },
  { path: 'ad-accounts', permission: 'view-ad-accounts' },
  { path: 'assets', permission: ['view-via-full', 'view-via-own', 'view-facebook-via'] },
  { path: 'via-facebook', permission: ['view-via-full', 'view-via-own', 'view-facebook-via'] },
  { path: 'billing-history', permission: 'view-billing' },
  { path: 'payment-invoices', permission: 'view-billing' },
  { path: 'payment-cards', permission: 'card-group.view' },
  { path: 'rental-customers', permission: 'view-rental-customers' },
  { path: 'telegram-company', permission: 'view-telegram-companies' },
  { path: 'bank-invoices', permission: 'view-bank-invoices' },
  { path: 'financial-dashboard', permission: 'view-financial-dashboard' },
  { path: 'users', permission: 'manage-users' },
  { path: 'roles', permission: 'manage-permissions' },
  { path: 'permissions', permission: 'manage-permissions' },
  { path: 'role-management', permission: 'manage-users' },
  { path: 'permission-groups', permission: 'manage-permissions' },
  { path: 'bank-balance', permission: 'view-bank-balances' },
  { path: 'action-history', permission: 'view-action-history' },
  { path: 'tag-settings' },
  { path: 'shields' },
  { path: 'form-request' }
]

export function orgPath(orgId, path = '') {
  const cleanPath = String(path || '').replace(/^\/+/, '')
  return `/${orgId}/admin${cleanPath ? `/${cleanPath}` : ''}`
}

export function isSystemAdmin(user) {
  return user?.roles?.some((role) => ['sysadmin'].includes(role.slug)) ?? false
}

export function getDefaultAdminRoute(authStore, orgId) {
  if (isSystemAdmin(authStore.user)) {
    return orgPath(orgId, 'dashboard')
  }

  for (const route of ADMIN_ROUTE_PRIORITY) {
    if (route.permission && authStore.hasPermission(route.permission)) {
      return orgPath(orgId, route.path)
    }
  }

  return orgPath(orgId, 'dashboard')
}

export function isOrgMember(user, orgId) {
  const organizations = user?.organizations || []
  return organizations.some((org) => String(org.id) === String(orgId))
}

export function resolveOrgRouteAccess({ orgId, user, currentOrganizationId }) {
  if (!isOrgMember(user, orgId)) {
    return { action: 'redirect', path: '/select-organization' }
  }

  if (String(currentOrganizationId) !== String(orgId)) {
    return { action: 'select', orgId }
  }

  return { action: 'allow' }
}

export function resolvePostLoginDestination(user, currentOrganizationId) {
  const organizations = user?.organizations || []

  if (organizations.length === 1) {
    return { action: 'enter', orgId: organizations[0].id }
  }

  return { action: 'pick' }
}

export async function redirectAfterAuth(router, authStore) {
  const pendingRedirect = router.currentRoute?.value?.query?.redirect
  const destination = resolvePostLoginDestination(authStore.user, authStore.currentOrganizationId)

  if (destination.action === 'pick') {
    router.push(
      pendingRedirect
        ? { path: '/select-organization', query: { redirect: pendingRedirect } }
        : '/select-organization'
    )
    return
  }

  if (String(authStore.currentOrganizationId) !== String(destination.orgId)) {
    await authStore.selectOrganization(destination.orgId)
  }

  router.push(pendingRedirect || getDefaultAdminRoute(authStore, destination.orgId))
}
